const state = {
    sidebarOpen: false,
    firstProduk: false,
    toast: {},
    isLogin: false,
    user: {},
    toko: {},
    menuActive: "",
    namaPaket: "",
}

const getters = {
    baseUrl: state => state.settings || 'NotSet',
}

const mutations = {
    setSidebarOpen(state, val) {
        state.sidebarOpen = val
    },
    setFirstProduk(state, val) {
        state.firstProduk = val
    },
    setToast(state, val) {
        state.toast = val
    },
    closeToast(state) {
        state.toast.open = false
    },
    setMenuActive(state, val) {
        state.menuActive = val
    },
    setNamaPaket(state, val) {
        state.namaPaket = val
    },
    setLogin(state, val) {
        state.isLogin = val.isLogin
        state.user = val.user
        state.toko = val.toko
    },
    setToko(state, val) {
        state.toko = val
    }
}

const actions = {}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/settings.js